/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { BridgeCommands } from 'bridge-commands/bridge.commands';

export class BridgeMock {
    command: BridgeCommands.Command<object, any>;
    return: any;
}

@Injectable()
export class BridgeConfig {
    mocks?: BridgeMock[];
    cacheMockedCallData?: boolean;
}
